import { render } from "./ContentHolder.vue?vue&type=template&id=ab8c8126"
import script from "./ContentHolder.vue?vue&type=script&lang=js"
export * from "./ContentHolder.vue?vue&type=script&lang=js"

import "./ContentHolder.vue?vue&type=style&index=0&id=ab8c8126&lang=scss&scope=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__